module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-106.f46e48e5.svg";